import VersionSupportModal from './version-support-modal.connect'

export default VersionSupportModal
